/** Merge class names, filtering out falsy values. */
export function cn(...classes) {
    return classes.filter(Boolean).join(" ");
}
//# sourceMappingURL=utils.js.map